import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";

function CommonDataGrid({
  rows = [],
  columns = [],
  rowCount = 0,
  loading = false,
  paginationModel,
  onPaginationModelChange,
  sortModel,
  onSortModelChange,
  getRowId = row => row.id,
  initialSortField = "id",
  initialSortOrder = "asc", 
  getRowClassName,
  ...rest
}) {
  return (
    <DataGrid
      rows={rows}
      columns={columns}
      rowCount={rowCount}
      loading={loading}
      paginationMode="server"
      sortingMode="server"
      paginationModel={paginationModel}
      onPaginationModelChange={onPaginationModelChange}
      sortModel={sortModel}
      onSortModelChange={onSortModelChange}
      getRowId={getRowId}
      disableRowSelectionOnClick
      disableColumnMenu
      getRowClassName={getRowClassName}     
      sortingOrder={["desc", "asc"]}
      columnHeaderHeight={52}
      rowHeight={54}
      pageSizeOptions={[5, 10, 25, 50, 100]}
      sx={{
        border: "1px solid #dbe5ee",
        borderRadius: "8px",
        overflow: "hidden",
        backgroundColor: "#fff",
        color: "#27384a",
        fontFamily: "'DM Sans', sans-serif",
        boxShadow: "0 8px 22px rgba(31, 45, 61, 0.05)",
        "& .MuiDataGrid-main": {
          backgroundColor: "#fff",
        },
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: "#f4f8fb",
          borderBottom: "1px solid #d9e4ee",
        },
        "& .MuiDataGrid-columnHeader": {
          color: "#20384f",
          fontSize: "12px",
          fontWeight: 800,
          letterSpacing: "0.03em",
          textTransform: "uppercase",
          padding: "0 14px",
          outline: "none !important",
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          fontWeight: 800,
        },
        "& .MuiDataGrid-columnSeparator": {
          display: "none",
        },
        "& .MuiDataGrid-cell": {
          borderBottom: 0,
          fontSize: "13px",
          lineHeight: 1.5,
          padding: "0 14px",
          outline: "none !important",
          display: "flex",
          alignItems: "center",
        },
        "& .MuiDataGrid-row": {
          backgroundColor: "#fff",
        },
        "& .MuiDataGrid-row:nth-of-type(even)": {
          backgroundColor: "#fbfdff",
        },
        "& .MuiDataGrid-row:hover": {
          backgroundColor: "#eef6fb",
        },
        "& .MuiDataGrid-row.Mui-selected, & .MuiDataGrid-row.Mui-selected:hover": {
          backgroundColor: "#e8f2fa",
        },
        "& .MuiDataGrid-footerContainer": {
          borderTop: "1px solid #e3eaf1",
          backgroundColor: "#fff",
        },
        "& .MuiDataGrid-cell .MuiIconButton-root": {
          width: 34,
          height: 34,
          color: "#4d80aa",
        },
        "& .MuiDataGrid-cell .badge": {
          padding: "5px 9px",
          fontSize: "11px",
          lineHeight: 1,
        },
        "& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus-within": {
          outline: "none",
        },
      }}
      initialState={{
        sorting: {
          sortModel: [{ field: initialSortField, sort: initialSortOrder }],
        },
      }}
      {...rest}
    />
  );
}

export default CommonDataGrid;

CommonDataGrid.propTypes = {
  rows: PropTypes.any,
  columns: PropTypes.any,
  rowCount: PropTypes.any,
  loading: PropTypes.any,
  paginationModel: PropTypes.any,
  onPaginationModelChange: PropTypes.any,
  sortModel: PropTypes.any,
  onSortModelChange: PropTypes.any,
  getRowId: PropTypes.any,
  initialSortField: PropTypes.any,
  initialSortOrder: PropTypes.any,
};
